export default __webpack_public_path__ + "static/media/logoMini.7ba4aaec.svg";